import { WithChildren } from "../../types";
import { LightBulb } from "../Icons";
import styles from "./Tip.module.css";

type ComponentProps = WithChildren;

export const Tip = ({ children }: ComponentProps) => (
  <div className={styles.tip}>
    <div className={styles.icon}>
      <LightBulb height='50px' width='50px' />
    </div>
    <div>{children}</div>
  </div>
);
